const theme = {
    // Temp fonts
    fonts: {
      title: "Space Grotesk, sans-serif",
      main: "Space Grotesk, sans-serif"
    },
    // Colors for layout
    colors: {
      primary1: "hsl(204,23.8%,95.9%)",
      background1: "#0F1624",
      accent1: "hsl(34.9,98.6%,72.9%)",
      button: "hsl(205.1,100%,36.1%)",
      background2: "hsl(232.7,27.3%,23.7%)",
    },
    // Breakpoints for responsive design
    breakpoints: {
      sm: 'screen and (max-width: 730px)',
      md: 'screen and (max-width: 960px)',
      lg: 'screen and (max-width: 1024px)'
    },
  }
  
  export default theme;